import { useEffect } from "react";
import { useStoreSongs } from "../store";

const safeLocalStorage = {
    getItem(key) {
        try {
            return typeof window !== 'undefined' ? window.localStorage.getItem(key) : null
        } catch (_error) {
            return null
        }
    },
    setItem(key, value) {
        try {
            if (typeof window !== 'undefined') {
                window.localStorage.setItem(key, value)
            }
        } catch (_error) {
            // ignore
        }
    }
}

export default function useSetlist() {
    const { setlist, songs } = useStoreSongs()

    useEffect(() => {
        const localSongs = safeLocalStorage.getItem('songlist')
        if (localSongs) {
            useStoreSongs.setState({ songs: JSON.parse(localSongs) })
        }
    }, [])

    const toSongList = (newSong) => {
        const newSongs = songs.filter((song) => song.title !== newSong.title)
        useStoreSongs.setState({ songs: [...newSongs, newSong] })
        safeLocalStorage.setItem('songlist', JSON.stringify([...newSongs, newSong]))
    }

    const removeSong = (deleteSong, onDelete) => {
        const newSongs = songs.filter((song) => song.title !== deleteSong.title)
        useStoreSongs.setState({ songs: newSongs })
        safeLocalStorage.setItem('songlist', JSON.stringify(newSongs))

        onDelete && onDelete(deleteSong)
    }

    const fixedSong = (tagSong, onFixed) => {
        const newSongs = songs.map((song) => {
            if (tagSong.title === song.title) {
                return {
                    ...song,
                    fixed: !song.fixed
                }
            }
            return song
        })

        onFixed && onFixed(tagSong)

        useStoreSongs.setState({ songs: newSongs })
        safeLocalStorage.setItem('songlist', JSON.stringify(newSongs))
    }

    const filteredSong = (value) => {
        return songs.filter((song) => {
            return String(song.title).toLowerCase().includes(String(value).toLowerCase())
        })
    }

    return {
        setlist,
        songs,
        toSongList,
        removeSong,
        fixedSong,
        filteredSong
    }
}
